import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const videoPlayerRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const image = selector('[data-motion-image]')[0]
  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]
  const cta = selector('[data-motion-cta]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let imageAnimation: SharedAnimation
  if (image) {
    imageAnimation = {
      timeline: gsap
        .timeline()
        .fromTo(
          image,
          { scale: 0.2, opacity: 0 },
          { scale: 1, opacity: 1, duration: 1.6, ease: 'power2.out' }
        ),
      revert: () => {
        return
      }
    }
    timeline.add(imageAnimation.timeline, 0)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0.5)
  }

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = linesRevealAnimation(text, reverse)
    timeline.add(textAnimation.timeline, 0.6)
  }

  let ctaAnimation: SharedAnimation
  if (cta) {
    ctaAnimation = fadeRevealAnimation(cta)
    timeline.add(ctaAnimation.timeline, 0.7)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    imageAnimation?.revert()
    titleAnimation?.revert()
    textAnimation?.revert()
    ctaAnimation?.revert()
  }
}
